import { useEffect } from 'react';
import { useUIPrefsStore } from '../store/useUIPrefsStore';
import { ESCALA_DEFAULT, escalaSiguiente, escalaAnterior } from '../utils/uiPrefs';

/**
 * Sprint 40 — Atajos globales de accesibilidad.
 *
 * - `Ctrl + +` / `Ctrl + =` (misma tecla en US/LatAm) → escala siguiente
 * - `Ctrl + -`                                       → escala anterior
 * - `Ctrl + 0`                                       → reset a 'normal'
 *
 * Se ignoran si el foco está dentro de un input/textarea/contentEditable
 * (no queremos pisar atajos del editor del usuario).
 */
export function useAtajosAccesibilidad(): void {
  const escala = useUIPrefsStore((s) => s.escala);
  const setEscala = useUIPrefsStore((s) => s.setEscala);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!e.ctrlKey && !e.metaKey) return;
      const target = e.target as HTMLElement | null;
      if (target) {
        const tag = target.tagName;
        if (
          tag === 'INPUT' ||
          tag === 'TEXTAREA' ||
          tag === 'SELECT' ||
          target.isContentEditable
        ) {
          return;
        }
      }
      if (e.key === '+' || e.key === '=') {
        e.preventDefault();
        void setEscala(escalaSiguiente(escala));
      } else if (e.key === '-') {
        e.preventDefault();
        void setEscala(escalaAnterior(escala));
      } else if (e.key === '0') {
        e.preventDefault();
        void setEscala(ESCALA_DEFAULT);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [escala, setEscala]);
}
